<mat-progress-bar *ngIf="loading" mode="indeterminate" />
<mat-card class="cardWithShadow">

    <!-- Skeleton -->
    <div *ngIf="loading" class="p-32">
        <ngx-skeleton-loader count="5" [theme]="{height: '30px'}" />
    </div>

    <mat-card-content *ngIf="!loading" class="p-y-32">
        <form [formGroup]="form">
            <ng-container>
                <mat-form-field class="w-100" appearance="outline">
                    <mat-label>Nome CER</mat-label>
                    <input autofocus matInput formControlName="name" placeholder="Nome CER">
                </mat-form-field>
            </ng-container>

            <div class="col-lg-12 p-x-0 d-flex gap-10">
                <!-- Latitudide -->
                <ng-container>
                    <mat-form-field class="w-50" appearance="outline">
                        <mat-label>Latitudine</mat-label>
                        <input matInput formControlName="lat" placeholder="Latitudine">
                    </mat-form-field>
                </ng-container>

                <!-- Longitude -->
                <ng-container>
                    <mat-form-field class="w-50" appearance="outline">
                        <mat-label>Longitudine</mat-label>
                        <input matInput formControlName="lon" placeholder="Longitudine">
                    </mat-form-field>
                </ng-container>
            </div>

            <div class="col-lg-12 p-x-0 d-flex gap-10" *ngIf="type === 'add'">
                <!-- Email -->
                <ng-container>
                    <mat-form-field class="w-50" appearance="outline">
                        <mat-label>Email utente</mat-label>
                        <input matInput formControlName="email" placeholder="Email">
                    </mat-form-field>
                </ng-container>
            </div>

            <div class="row w-100 text-center">
                <button mat-flat-button class="w-15 m-x-auto " color="primary" (click)="onSubmit()"
                    [disabled]="form.invalid">Salva</button>
            </div>
        </form>
    </mat-card-content>
</mat-card>